"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateActorInfo = exports.getCustomerUserName = exports.isContact = exports.isFortie = exports.CONTACT_ID = exports.FORTIE_ID = exports.USER_ID = void 0;
const Avatar_1 = require("../../../util/Avatar/Avatar");
exports.USER_ID = 'userId';
exports.FORTIE_ID = 'fortieId';
exports.CONTACT_ID = 'contactId';
const isFortie = (idType) => {
    return idType === exports.FORTIE_ID;
};
exports.isFortie = isFortie;
const isContact = (idType) => {
    return idType === exports.CONTACT_ID;
};
exports.isContact = isContact;
const getCustomerUserName = (actor) => actor ? `${actor.firstName} ${actor.lastName}` : '';
exports.getCustomerUserName = getCustomerUserName;
const generateActorInfo = (idType, actor) => {
    if ((0, exports.isFortie)(idType)) {
        const actorInfo = actor;
        return {
            id: actorInfo.id ?? '',
            email: actorInfo.email,
            name: actorInfo.name,
            avatarType: actorInfo.thumbnailUrl ? Avatar_1.AvatarType.THUMBNAIL_AVATAR : Avatar_1.AvatarType.INITIALS_AVATAR,
            thumbnailUrl: actorInfo.thumbnailUrl,
        };
    }
    if ((0, exports.isContact)(idType)) {
        const actorInfo = actor;
        return {
            id: actorInfo.id,
            email: actorInfo.email || '',
            name: actorInfo.contactPerson || 'External User',
            avatarType: Avatar_1.AvatarType.INITIALS_AVATAR,
        };
    }
    const actorInfo = actor;
    return {
        id: actorInfo.id || actorInfo._id,
        email: actorInfo.email,
        name: (0, exports.getCustomerUserName)(actorInfo),
        avatarType: Avatar_1.AvatarType.INITIALS_AVATAR,
    };
};
exports.generateActorInfo = generateActorInfo;
//# sourceMappingURL=Actors.js.map